import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation SendRegistrationConfirmation {
    sendRegistrationConfirmation {
      id
    }
  }
`;

export const sendRegistrationConfirmation = () =>
  executeGqlMutation({
    mutation: MUTATION,
  }).then(({ data }) => getSingleProp(data));
